(ns common.util
  (:require [clojure.string :as str]))

(defn new-uuid []  
  (let [words 
        (repeatedly 
          5 (partial rand-int 65536))]
    
    (str/join
      (map #(.slice
              (.toString % 36)
              -3)
           words))))

(defn mime->extension 
  "Extract a file extension from a mime type string"  
  [mime] 
  (->> mime 
       (re-find #"[/+]([^/+]+)$")
       (second)))